define(['underscore'], (_) => {

    function Vehicle(data) {
        if (data) {
            _.extend(this, data);
        }
    }

    /*
     * This method injects a functionality into vehicle to update relevant fields with the vehicle data coming from the Solr full text search
     * @Param {solrVehicle) SolrVehicle - dto retrieved from Solr, containing relevant data for a vehicle.
     */
    Vehicle.prototype.copyValuesFromSolrVehicle = function (solrVehicle, baslerTypelistMappingService) {

        this.id = solrVehicle.id;
        this.costNew = solrVehicle.preis;
        this.addlEquipmentValue = Math.round(solrVehicle.preis / 10);
        this.make = solrVehicle.markenName;
        this.model = solrVehicle.modelName;
        this.type = solrVehicle.typName;
        this.typeCertificateNumber = solrVehicle.typenscheinNummer;
        this.kwPower = solrVehicle.kw;
        this.horsePower = solrVehicle.ps;
        this.cubicCapacity = solrVehicle.hubraum;
        this.emptyWeight = solrVehicle.leerGewicht;
        this.totalWeight = solrVehicle.gesamtGewicht;
        this.doors = solrVehicle.tueren;
        this.seats = solrVehicle.anzahlPlaetze;
        this.co2Emission = solrVehicle.co2Emission;
        this.eurotaxNumber = solrVehicle.eurotaxNumber;

        if (this.typeCertificateNumber.lastIndexOf('0', 0) === 0 ||
            this.typeCertificateNumber.lastIndexOf('Z', 0) === 0) {

            // In that case the category and the type have to be selected manually by the user
            this.vehicleCategory = undefined;
            this.vehicleType = undefined;
        } else {
            // In the portal, the vehicle type and the vehicle category have to be set with the vehicle type coming from solr
            this.vehicleCategory = baslerTypelistMappingService.getVehicleCategoryByBaslerCode(solrVehicle.fahrzeugtyp);
            this.vehicleType = baslerTypelistMappingService.getVehicleTypeByBaslerCode(solrVehicle.fahrzeugtyp);
        }

        this.bodyType = baslerTypelistMappingService.getBodyTypeByBaslerCode(solrVehicle.karosserieart);
        this.driveType = baslerTypelistMappingService.getDriveTypeByBaslerCode(solrVehicle.treibstoffart);
        this.gearboxType = baslerTypelistMappingService.getGearboxTypeByBaslerCode(solrVehicle.getriebeart);
        this.checkSum = solrVehicle.checksum;
        this.power2MassRatio = solrVehicle.leistungsgewicht;
    };

    Vehicle.prototype.resetSorlValues = function () {
        this.costNew = undefined;
        this.addlEquipmentValue = undefined;
        this.make = undefined;
        this.model = undefined;
        //NOTE: this.type - do not reset, we need it to show entered field value
        this.typeCertificateNumber = undefined;
        this.kwPower = undefined;
        this.horsePower = undefined;
        this.cubicCapacity = undefined;
        this.emptyWeight = undefined;
        this.totalWeight = undefined;
        this.doors = undefined;
        this.seats = undefined;
        this.co2Emission = undefined;
        this.eurotaxNumber = undefined;
        this.vehicleCategory = undefined;
        this.vehicleType = undefined;
        this.bodyType = undefined;
        this.driveType = undefined;
        this.gearboxType = undefined;
        this.checkSum = undefined;
        this.power2MassRatio = undefined;
    };

    Vehicle.prototype.getVehicleCategory = function () {
        return this.vehicleCategory ? this.vehicleCategory : '';
    };

    Object.defineProperty(Vehicle.prototype, 'displayName', {
        get: function () {
            return `${this.make} ${this.type}`;
        },
    });

    return Vehicle;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/models/Vehicle.js